import React from "react";

function Footer() {
  return (
    <footer className="footer">
      <p>© 2026 Prema's HomeCare</p>
    </footer>
  );
}

export default Footer;
